export default "__VITE_ASSET__dc883514__"